import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            notification_header: {
              tab_name: 'TAB_NAME',
              namespace: 'NAMESPACE',
              for_anonymous: 'FOR_ANONYM',
              for_affiliates: 'FOR_AFFILIATE',
              header_color: 'HEADER_COLOR',
              text_color: 'TEXT_COLOR',
              language: 'LANGUAGE',
              text_content: 'TEXT_CONTENT',
              state: 'STATE',
            },
          },
        },
      },
    },
    common: {
      notification: {
        no_any_notification: 'NO_ANY_NOTIFICATION',
      },
    },
  }));
}
